export const ACCORDION_KEYS = {
  KEY_FEATURES: 'key-features',
  DELIVERY: 'delivery',
  RETURNS_WARRANTY: 'returns-warranty',
  DOWNLOADS: 'downloads',
  ACCESSORIES: 'accessories',
} as const;

export type AccordionKey = ValueOf<typeof ACCORDION_KEYS>;
